export default {
    namespaced: true,
    state: {
        lastAttachmentId: null

    },

    mutations: {
        SET_LAST_ATTACHMENT_ID(state, id) {
            state.lastAttachmentId = id;
        },
        CLEAR_LAST_ATTACHMENT_ID(state) {
            state.lastAttachmentId = null;
        }
    },
};
